import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import useBreakpoints from '@/core/responsive/breakpoints/breakpoint.mixin';
import { computed, reactive, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    isOpen: { type: Boolean },
    renderDark: { type: Boolean },
    centerBody: { type: Boolean },
    fullScreenContent: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({(e: 'close'): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {isOpen?: boolean, renderDark?: boolean, centerBody?: boolean, fullScreenContent?: boolean}



const theme = computed<ColorTheme>(() => store.getters['app/theme']);
const modalCloseBtnContainerWidth = reactive<any>({
    width: '100%'
});
const breakpointIsActive = useBreakpoints();

// hack to make size the button container to the with of the content if there is a scrollbar
function onIsOpenChanged() {
    setTimeout(() => {
        const modalContentEl = document.getElementById('modalContent');
        if (props.isOpen && modalContentEl && breakpointIsActive.value.large) {
            modalCloseBtnContainerWidth.width = `calc(100% - (${window.innerWidth}px - ${modalContentEl.clientWidth}px))`;
        } else {
            modalCloseBtnContainerWidth.width = '100%';
        }
    }, 400);
}
watch(() => props.isOpen, onIsOpenChanged);

function close() {
    emit('close');
}

function backgroundClose(event: Event) {
    if (props.renderDark) {
        const modal = document.getElementById('modalContent');
        if (modal && modal === event.target) {
            close();
        }
    }
}

const modalCustomStyle = computed<string>(() => {
    let content = '';
    if (!props.renderDark && theme.value.pageBackgroundColor) {
        content += `background-color: ${theme.value.pageBackgroundColor} !important;`;
    }
    if (theme.value.textColor) {
        content += `color: ${theme.value.textColor} !important;`;
    }
    if (content) {
        return `.modal-custom-style { ${content} }`;
    }
    return '';
});

return { __sfc: true,props, emit, theme, modalCloseBtnContainerWidth, breakpointIsActive, onIsOpenChanged, close, backgroundClose, modalCustomStyle }
}

})